import Decimal from 'decimal.js';

interface ODecimal extends Decimal {
  _plus?: (n?: Decimal.Value) => ODecimal | undefined;
}

const decimal = (num?: number): ODecimal | undefined => {
  if (num === undefined || num === null) {
    return undefined;
  }

  const dec = new Decimal(num) as ODecimal;

  dec._plus = (num?: Decimal.Value) => {
    if (num === undefined || num === null) {
      return undefined;
    }

    return dec.plus(num);
  };

  return dec;
};

export default decimal;
